<template>
	<div id="jljw_IM_GdImBox" ref="r_jljw_IM_GdImBox">
		<div
			class="GdImMiniBox"
			@click="showImPanel"
			:class="{ isAct: this.showIM }"
		>
			<span class="imbtn-icon"></span>
			<!-- 铃铛 -->
			<!-- <span class="mobmessagehint" v-show="mobmessagehint || true"></span> -->
			<!-- 数量 -->
			<span class="mobmessagehintnum" v-show="mobmessagehint">{{
				numMsgUnRead
			}}</span>
		</div>
		<div class="GdImBox" ref="r_GdImBox" :class="{ is_act: this.showIM }">
			<div class="cbTitle">
				<div class="gimicf" :class="pointState">
					<img
						v-if="!!headImg"
						:src="headImg"
						class="serhead"
						style="margin-right: 10px"
					/>
					<div class="serhead-wrap" v-else>
						<i class="serhead"></i>
					</div>
					<div class="jljw_IM_Server_Title">
						<p>
							{{ serviceName }}
							<span class="typing">{{ typing || "正在输入中..." }}</span>
						</p>
						<p :title="desc">{{ desc }}</p>
					</div>
				</div>
				<div class="back" @click="showIM = false"></div>
			</div>
			<MessageContent
				ref="msgView"
				:message="message"
				:user-name="uid"
				:aiState="aiState"
				:headImg="headImg"
				:serviceName="serviceName"
				@preview="viewImage"
				@switchAi="onSwitchAi"
				@talk="onTalk"
				:isLostConn="isLostConn"
				:isCloseQuote="isCloseQuote"
				v-show="!loadingShow"
			/>
			<!--      <SendBox-->
			<!--        :room-name="uid"-->
			<!--        @image="onImage"-->
			<!--        @file="onFile"-->
			<!--        @audio="onAudio"-->
			<!--        @video="onVideo"-->
			<!--        @talk="onTalk"-->
			<!--      />-->
      <div style="relative" class="im-loading" v-show="loadingShow">
        <img src="@/assets/img/loading1.gif" width="60" height="60">
      </div>
			<SendBox
				ref="sendBoxView"
				:room-name="uid"
				:disabled="dis_send"
				@image="onImage"
				@file="onFile"
				@talk="onTalk"
				@preMsg="onPreMsg"
        v-show="sendBoxShow"
			/>

			<!-- 新增询盘结构-开始 -->
			<div class="jljw_IM_inquiry" ref="r_jljw_IM_inquiry">
				<div class="jljw_IM_item" v-if="show.isName">
					<span class="jljw_IM_label"
						>Your name <em v-if="data.isNameRequired">*</em></span
					>
					<input type="text" ref="jljw_IM_Name" @blur="checkOnBlur" />
				</div>
				<div class="jljw_IM_item" v-if="show.isEmail">
					<span class="jljw_IM_label"
						>E-mail <em v-if="data.isEmailRequired">*</em></span
					>
					<input type="text" ref="jljw_IM_mail" value="" @blur="checkOnBlur" />
				</div>
				<!-- Phone/WhatsApp 新加的 -->
				<div class="jljw_IM_item" v-if="show.isPhone">
					<span class="jljw_IM_label"
						>Phone/WhatsApp <em v-if="data.isPhoneRequired">*</em></span
					>
					<input type="text" ref="jljw_IM_phone" value="" @blur="checkOnBlur" />
				</div>
				<!--  -->
				<div class="jljw_IM_item" v-if="show.isText">
					<span class="jljw_IM_label"
						>Message <em v-if="data.isTextRequired">*</em></span
					>
					<textarea
						type="text"
						ref="jljw_IM_textarea"
						@blur="checkOnBlur"
					></textarea>
				</div>
				<div class="jljw_IM_item">
					<button class="jljw_IM_btn" id="jljw_IM_btn" @click="btnSendEmail">
						SUBMIT
					</button>
				</div>
				<!-- 这个是没有必填的时候显示出来 -->
				<div class="GdImBox-hit" v-if="isGdImBoxHit">
					<span v-if="isShowHint">
						{{ msgPanelTips }}
					</span>
				</div>
				<!--  -->
				<!--  <div class="jljw_IM_hint">
          <p class="jljw_IM_hint_mail">{{msgEmailTips}}</p>
        </div> -->
				<div class="jljw_IM_success" v-if="loadingState > 0">
					<img
						v-if="loadingState === 1"
						src="data:image/gif;base64,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"
						alt=""
					/>
					<img
						class="success"
						v-if="loadingState === 2"
						src="data:image/png;base64,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"
						alt=""
					/>
				</div>
			</div>
			<!-- 新增询盘结构-结束 -->
			<div
				class="nsiosbox"
				:style="{
					display: uploadStep > 0 && uploadStep < 100 ? 'block' : 'none',
				}"
			>
				upload percent: {{ uploadStep }}%
			</div>
		</div>
		<div
			id="tinymask"
			:style="{ display: preview ? 'block' : 'none' }"
			@click="cancelView"
		></div>
		<div
			class="tinybox"
			:style="{ display: preview ? 'block' : 'none' }"
			@click="cancelView"
		>
			<img :src="viewImg" alt="" />
		</div>
	</div>
</template>

<script>
import MessageContent from "./components/MessageContent";
import SendBox from "./components/SendBox";
import { UploadFile } from "@/api/common";
import { getLocalStorage, setLocalStorage } from "@/utils/local-storage";
import { beetlex, beetlexAction } from "@/utils/beetlex4axios";
import accessLog from "@/utils/accessLog";
import markdownIt from "markdown-it";

export default {
	name: "App",
	components: {
		MessageContent,
		SendBox,
	},
	data() {
		return {
			uid: "",
      loadingShow:true, //显示加载中
      sendBoxShow:false, //输入框显示
			roomInfo: {}, // 房间消息，非常重要，安全考虑可能后续要想办法在访客端去掉这个 2024年12月09日
			message: [],
			getUser: new beetlexAction("/GetUser"),
			login: new beetlexAction("/Login"),
			createRoom: new beetlexAction("/CreateRoom"),
			enterRoom: new beetlexAction("/Enter"),
			exitRoom: new beetlexAction("/Exit"),
			chatLog: new beetlexAction("/ChatLog"),
			read: new beetlexAction("/Read"),
			talk: new beetlexAction("/Talk"),
			Withdraw: new beetlexAction("/Withdraw"),
			saveFormMsg: new beetlexAction("/SaveFormMsg"),
			image: new beetlexAction("/Image"),
			file: new beetlexAction("/File"),
			// audio: new beetlexAction("/Audio"),
			// video: new beetlexAction("/Video"),
			preMsg: new beetlexAction("/Preview"),
			getRoomInfo: new beetlexAction("/RoomInfo"),
			// check: new beetlexAction("/Check"),
			welcome: new beetlexAction("/Welcome"),
			defaultMsg: new beetlexAction("/DefaultMessage"),
			switchAi: new beetlexAction("/AiState"),
			showIM: false,
			showIMByClick: false,
			preview: false,
			viewImg: "",
			serviceName: "",
			notify: "",
			firstWelcome: false,
			uploadStep: 0,
			accessLog: new accessLog(),
			title: "",
			isShine: false,
			preMsgTimeout: 0,
			headImg: "",
			desc: "",
			isLostConn: false,
			isCloseQuote: false,
			msgEmailTips: "",
			isShowHint: false,
			msgPanelTips: "",
			heightGDImbBox: 560,
			loadingState: 0,
			pointState: "gimicf",
			numMsgUnRead: 0,
			// 新加
			name: "",
			email: "",
			phone: "",
			text: "",
			// 显示隐藏
			show: {
				isName: true,
				isEmail: true,
				isPhone: true,
				isText: true,
			},
			// 必填
			data: {
				isNameRequired: false,
				isEmailRequired: false,
				isPhoneRequired: false,
				isTextRequired: false,
			},
			isGdImBoxHit: false,
			aiState: 1,
			dis_send: false,

			mobmessagehint: false,

			typing: "", // 正在输入中

			//
			app_alert: false, // APP 是否开启每日首条新消息弹出
			pc_alert: false, // APP 是否开启每日首条新消息弹出
		};
	},
	created() {
		var isBot =
			navigator.webdriver ||
			/bot|spider|crawl|slurp|mediapartners/i.test(navigator.userAgent);
		if (isBot) {
			return;
		}
		// setTimeout(()=>{
		//   this.initPanelEmail();
		// },1000);
		// debugger;
		// if (process.env.NODE_ENV === "development") {
		//   let { uid } = getLocalStorage("serviceId");
		//   if (!uid) {
		//     window.localStorage.setItem("serviceId", this.$dev_id);
		// }
		// }
		let { serviceId } = getLocalStorage("serviceId");
		if (serviceId) {
			// console.log(serviceId);
		} else {
			serviceId = 0;
			setLocalStorage({ serviceId: serviceId });
		}

		let that = this;
		that.pointState = "gimicf";
		beetlex.onLostConn = () => {
			// console.log("断线了");
			that.isLostConn = true;
		};
		beetlex.websocket.connected = function() {
			that.isLostConn = false;
			let { uid } = getLocalStorage("uid");
			if (uid) {
				// console.log(uid);
			} else {
				that.getUser
					.post({})
					.then((data) => {
						uid = data;
						setLocalStorage({ uid: uid });
					})
					.catch((err) => {
						// console.log(err);
						uid = "TMP" + that.getRandomString();
						setLocalStorage({ uid: uid });
					});
			}

			that.onLogin();

			// 获取所有发送失败的消息
			let msgSendFail = [];
			for (let i = 0; i < that.message.length; i++) {
				let msgItem = that.message[i];
				if (msgItem.sendFail) {
					msgSendFail.push(msgItem);
				}
			}
			// 移除发送失败的消息，并重发到服务器
			for (let i = 0; i < msgSendFail.length; i++) {
				let msgItem = msgSendFail[i];
				setTimeout(() => {
					let indexIn = that.message.indexOf(msgItem);
					if (indexIn > -1) {
						that.message.splice(indexIn, 1);
					}
					that.onTalk(msgItem.message);
				}, 10);
			}
		};

		// 处理接收到的消息
		// 如果消息发送失败，更新连接状态为false，websocket已经断连
		// 处理不同类型的消息
		beetlex.websocket.receive = function(msg) {
			// 过滤目标键（监听键名为 ${msg.room}_isRead 的变化）
			window.addEventListener("storage", function(event) {
				if (event.key === `${msg.room}_isRead`) {
					if (event.newValue == 0) {
						that.mobmessagehint = false;
					}
				}
			});

			if (!msg.sendFail) that.isLostConn = false;
			// ？？？代码逻辑不清晰

			// 将 historyTime 定义在外部，作为全局变量
			let historyTime = Number(localStorage.getItem(`${that.uid}_historyTime`)); // 获取历史记录时间戳

			if (localStorage.getItem("todayappnewsopenShowIM") == null) {
				localStorage.setItem("todayappnewsopenShowIM", 0); // 初始化标记首次弹出为0
			}
			if (msg.type === "talk") {
				var dateTime = msg.dateTime;
				var timestamp = new Date(dateTime).getTime();

				/********** 2025-04-21 修改弹出逻辑 新增APP判断 ***************************/
				// 检查是否应该重置每日首条消息标记
				const today = new Date().toISOString().split("T")[0]; // 获取当前日期，格式如 "2023-05-21"
				const lastCheckedDay = localStorage.getItem("lastCheckedDay");

				// 如果是新的一天，重置标记
				if (lastCheckedDay !== today) {
					localStorage.removeItem("todayappnewsopenShowIM");
					localStorage.setItem("lastCheckedDay", today);
				}
				// 每日首次弹出逻辑
				if (timestamp > historyTime) {
					// 检查是否为移动设备
					let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
						navigator.userAgent
					);

					// 如果是移动设备，且开启移动端首次提醒，且今天还没有弹出过新消息
					// 不管是pc还是app，都只可触发一次首次弹出
					if (isMobile) {
						if (
							that.app_alert &&
							(localStorage.getItem("todayappnewsopenShowIM") == 0 ||
								localStorage.getItem("todayappnewsopenShowIM") === null)
						) {
							that.showIM = true;
							localStorage.setItem("todayappnewsopenShowIM", 1); // 标记今天已经显示过消息
						}
					} else {
						// 如果不是移动设备，且开启了桌面端首次提醒，且今天还没有弹出过新消息
						if (
							that.pc_alert &&
							(localStorage.getItem("todayappnewsopenShowIM") == 0 ||
								localStorage.getItem("todayappnewsopenShowIM") === null)
						) {
							that.showIM = true;
							localStorage.setItem("todayappnewsopenShowIM", 1); // 标记今天已经显示过消息
						}
					}
				}

				// 判断单独的新消息是否弹出
				if (timestamp > historyTime) {
					let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
						navigator.userAgent
					);
					if (isMobile) {
						if (msg.appAlert) {
							that.showIM = true;
						}
					} else {
						if (msg.isAlert) {
							that.showIM = true;
						}
					}
				}
			}	
			// 注释掉下面的代码 2025-04-21
			// // 历史记录时间戳，打开时记录一下
			// if (historyTime === "") {
			//   historyTime = Date.now();
			// }
			// // console.log(historyTime); // 获取当前时间戳
			// if (msg.type === "talk") {
			//   var dateTime = msg.dateTime;
			//   var timestamp = new Date(dateTime).getTime();
			//   // console.log(timestamp); // 当前消息的时间戳
			//   if (historyTime < timestamp) { // 只判断新消息
			//     // 判断 isAlert 是否自动弹出
			//     if (msg.isAlert == true) {
			//       // that.showIM = true;
			//     }
			//   }
			// }
			/********** 2025-04-21 修改弹出逻辑 新增APP判断 ***************************/

			// preview 客服是否在输入中
			if (msg.type === "preview") {
				const state = msg.state;
				that.typing = msg.msg;
				if (state == 1) {
					// 客服在输入中
					document.querySelector(
						"#jljw_IM_GdImBox .jljw_IM_Server_Title .typing"
					).style.display = "inline";
				} else {
					// 不在输入中，其他情况
					document.querySelector(
						"#jljw_IM_GdImBox .jljw_IM_Server_Title .typing"
					).style.display = "none";
				}
			}

			if (msg.type === "read") {
				that.onRead(msg);
				return;
			}
			// 如果是通知类型的消息，则考虑如下动作： 客服离线了，或者拉取一下消息？？？
			if (msg.type === "notify") {
				// that.notify = msg.message;
				if ("customer service offline" == msg.message) {
					// that.doWelcome();
					that.initPanelEmail();
					that.pointState = "gimicf";
				} else if (msg.message && msg.message.startsWith("reload:")) {
					that.roomInfo = JSON.parse(msg.room);
					// 为1时，屏蔽输入框
					// if(that.roomInfo.needForm === 1) {
					//  document.getElementById('jljw_IM_GdImBox').classList.add('forminput');
					// }else{
					//  document.getElementById('jljw_IM_GdImBox').classList.remove('forminput');
					// }
				} else if (
					msg.message &&
					(msg.message.includes("客服移交给") ||
						msg.message.includes("客服撤回一条消息"))
				) {
					// 检查是否已存在相同msgId的消息
					const isExist = that.message.some((m) => m.msgId === msg.msgId);

					if (!isExist) {
						that.message.push(msg);

						// 计入未读数量
						if (!that.showIM) {
							let { historyId } = getLocalStorage("historyId");
							if (msg.msgId > historyId) {
								that.mobmessagehint = true;
								that.numMsgUnRead++;
							}
						}
					}
				} else {
					// 这个逻辑可能有问题 删除试试，2024年12月09日，notify不需要拉取chatlog
					// that.chatLog.post({ room: that.uid });
				}

				return;
			}
			// 收到的撤回消息回调
			if (msg.type === "withdraw") {
				// console.log(that.message);
				// console.log('撤回回调', msg.msgid);
				// 找到并移除对应msgId的消息
				that.message = that.message.filter((item) => item.msgId !== msg.msgid);
				return;
			}
			// 如果是服务消息，在线，或者离线？service拿来做什么的？
			if (msg.type === "service") {
				that.serviceName = msg.user.nickName;
				that.headImg = msg.user.headImg;
				that.desc = msg.user.desc;
				if (that.aiState != msg.aiState) {
					that.aiState = msg.aiState;
				}

				if (msg.user.state === 1) {
					that.notify = "Online";
					that.pointState = "gimicfgreen";
					that.showPanelEmail(false);
				} else if (msg.user.state === 3) {
					// that.notify = "Mobile Online";
					// that.showPanelEmail(false);
					that.pointState = "gimicf";
					that.initPanelEmail();
				}
        
				// that.doWelcome();
				return;
			}
			// 进入房间消息，online和在线按钮显示情形
			if (msg.type === "enter") {
				if (msg.user && msg.user.type === 2) {
					that.serviceName = msg.user.nickName;
					that.notify = "Online";
					that.showPanelEmail(false);
					that.pointState = "gimicfgreen";
				} else {
					// that.message = [];
					that.chatLog.post({ room: that.uid });
				}        
				return;
			}
			// 离开房间消息，online和在线按钮显示情形
			if (msg.type === "quit") {
				if (msg.user && msg.user.type === 2) {
					setTimeout(function() {
						that.getRoomInfo.post({ room: msg.room }).then((data) => {
							let list = [];
							list.push(...data.onLine);
							list = list.filter((u) => u.type === 2);
							if (list.length > 0) {
								that.notify = "Online"; //多端，还有客服在房间
								that.showPanelEmail(false);
								that.pointState = "gimicfgreen";
							} else if (msg.user.state === 1) {
								that.notify = "Mobile Online"; //客服切后台
								that.showPanelEmail(false);
								that.pointState = "gimicfgreen";
							} else if (data.offLine && data.offLine.length > 0) {
								that.notify = "Mobile Online"; //多端，有客服在后台
								that.showPanelEmail(false);
								that.pointState = "gimicfgreen";
							} else {
								that.notify = ""; //"Offline"; //客服登出
								that.pointState = "gimicf";
								that.initPanelEmail();
							}
						});
					}, 1000);
				}
				return;
			}
			// history是做什么用的？？？？
			if (msg.history) {
				msg.read = undefined;
			} else {
				msg.read = false;
			}
			if (
				msg.type === "talk" ||
				msg.type === "askGuide" ||
				msg.type === "image" ||
				msg.type === "file" ||
				msg.type === "audio" ||
				msg.type === "video" ||
				msg.type === "contact" ||
				msg.type === "contactR"
			) {
				let isHave = false;

				//格式化md信息
				if (msg.isAIMsg) {
					msg.message = toMd(msg.message);
				}

				for (var i = that.message.length - 1; i >= 0; i--) {
					let msgItem = that.message[i];
					if (!msg.sendFail) {
						//只有当来自服务器的消息时， 才做下面的逻辑
						if (msgItem.sendFail && msgItem.clientMsgId == msg.clientMsgId) {
							that.message.splice(i, 1);
							break;
						}
					}

					if (!msgItem.sendFail && msgItem.msgId == msg.msgId) {
						isHave = true;
						break;
					}
				}

				if (!isHave) {
					// console.log(!msg.message)
					if (!!msg.message) {
						that.message.push(msg);
					}
				}
				that.message = that.message;
				let { historyId } = getLocalStorage("historyId");
				// 这个也不对，没有消息的时候，也有可能要更新已读未读的 2024年12月05日 所以这个if也不对
				if (msg.user && msg.user.name !== that.uid) {
					// let { historyId } = getLocalStorage("historyId");
					// 如果是历史消息，这里的判断是否显示是不正确的 先简单处理 2024年12月05日
					if (msg.msgId > historyId && msg.type !== "askGuide") {
						// setLocalStorage({ historyId: msg.msgId });
						// let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
						// if(msg.isAIMsg){
						//   // 如果是ai，则什么都不做，包括了pc平台
						// }
						// else if (isMobile) {
						console.log(that.message);
						
						that.showPopOrTips(true);
						if (!that.showIM) {
							// 2025年02月17日： 改为如果不弹出的状态下，直接提示
							// 并且是移动平台，就不弹出，2024年12月05日：加提示新消息
							// 提示新消息要根据read状态：如果窗口打开，就发给服务器，如果不打开，就不要发给服务器
							// that.mobmessagehint = true;
						} else {
							// console.log("来消息了，还是非ai和非手机的消息")
							// that.showIM = true;
						}
						that.showNotification(that.title, msg.message);
					}
					if (msg.msgId > historyId && that.showIM) {
						setLocalStorage({ historyId: msg.msgId });
						that.read
							.post({ room: msg.room, msgId: msg.msgId })
							.then((data) => {
								// console.log("已读", msg.room);
								if (data == 0) {
									localStorage.setItem(`${msg.room}_isRead`, 0);

									setTimeout(() => {
										localStorage.setItem(`${msg.room}_isRead`, 1);
									}, 2000);
								}
							});
					}
					// 如果是历史消息，这里的判断是否显示是不正确的 先简单注释处理 2024年12月05日
				}
			}

			//MD格式
			let idInterVal = 0;
			let indexTime = 0;
      let flag = true
			if (msg.type == "stream-start") {
				idInterVal = setInterval(() => {
					let md_message = that.message.find((w) => w.writing == true);
					if (md_message) {
						md_message.message = indexTime % 2 == 1 ? "." : "...";
					}
					// if (indexTime++ > 5) {
					// 	clearInterval(idInterVal);
					// 	// 恢复按钮
					// 	that.dis_send = false;
					// 	// 移除ai创建的消息
					// 	that.message.forEach(function(item, index, arr) {
					// 		if (item === md_message) {
					// 			arr.splice(index, 1);
					// 		}
					// 	});
					// }
          indexTime++
				}, 1000);

				//新建一行信息
				let md_message = msg;
				md_message.isAIMsg = true;
				md_message.message = "";
				md_message.message_ai = "";
				md_message.type = "talk";
				md_message.writing = true;
				that.message.push(md_message);
				that.dis_send = true;
			} else if (msg.type == "stream") {
				clearInterval(idInterVal);    
				let md_message = that.message.find((w) => w.writing == true);
				if (md_message) {
					md_message.message_ai += msg.message;
					md_message.message = toMd(md_message.message_ai);

					setTimeout(function() {
						const msgList = document.getElementById("msgList");
						const scrollHeight = msgList.scrollHeight;
						msgList.scrollTo({
							top: scrollHeight,
							behavior: "smooth", // 可选，使用平滑滚动
						});
					}, 200);
				}
			} else if (msg.type == "stream-end") {
				clearInterval(idInterVal);
				let md_message = that.message.find((w) => w.writing == true);
				if (md_message) {
					md_message.writing = false;
				}
				that.dis_send = false;
			}
		};

		function toMd(str) {
			return markdownIt({
				breaks: true,
				linkify: true,
				typographer: true,
			}).render(str.replace(/^(\s+)\|/gm, "|"));
		}

		beetlex.websocket.exception = function(code, message) {
			if (code == 503) {
				beetlex.websocket.close();
				that.serviceName = "";
				that.notify = message;
			}
		};
		beetlex.useWebsocket(this.$baseURL);
		this.accessLog.setBaseUrl(this.$accessLog);

		window.addEventListener("beforeunload", this.unLoadPage);

		this.title = document.title;
		window.onfocus = function() {
			that.isShine = false;
		};
		window.onblur = function() {
			that.isShine = true;
		};

		// this.statusCheck();
	},
	beforeDestroy() {
		this.unLoadPage();
	},
	destroyed() {
		window.removeEventListener("beforeunload", this.unLoadPage);
	},
	methods: {
		showPopOrTips(isShow) {
			var showDefault = isShow;
			let { popwin } = getLocalStorage("popwin");	
			let configShowIM = true;
			if (popwin == null) {
				// 兼容老旧版本
				configShowIM = false;
			} else {
				let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				);
				isMobile = false; // 2025年02月25日，强行修改移动端为pc逻辑
				// 1：都关闭(默认）
				// 2：都自动弹出
				// 3：pc关闭，手机弹出
				// 4：pc弹出，手机关闭
				if (popwin == 1 || popwin == "1") {
					configShowIM = false; // 都不弹出
				} else if (popwin == 2 || popwin == "2") {
					configShowIM = true; // 都自动弹出
				} else if (popwin == 3 || popwin == "3") {
					if (isMobile) {
						configShowIM = true; // 手机弹出
					}
				} else if (popwin == 4 || popwin == "4") {
					if (!isMobile) {
						configShowIM = true; // pc弹出
					}
				}
				// 手机上全部不弹出 2024年12月04日
				if (isMobile) configShowIM = false;
			}
			if (!configShowIM) isShow = false; // 配置不弹出时，为最高优先级的规则
			if (!this.showIM) this.showIM = isShow; // 是否弹出,防止打开状态时被关掉了，2025年02月21日
			// 如果打算显示弹出，但是未成功时，直接出现小图标提示！ 2025年02月17日
			this.checkUnreadMsgs();
			if (showDefault && !this.showIM) this.mobmessagehint = true;
		},
		showImPanel() {
			this.showIM = true;
			this.mobmessagehint = false;
			this.numMsgUnRead = 0;
			// console.log("showIMByClick 点击过了IM")
			this.showIMByClick = true;

			if (this.message.length > 0) {
				var msg = this.message[this.message.length - 1];
				let { historyId } = getLocalStorage("historyId");
				if (msg.msgId > historyId) {
					setLocalStorage({ historyId: msg.msgId });
					this.read.post({ room: msg.room, msgId: msg.msgId }).then((data) => {
						// console.log("已读", msg.room);
						if (data == 0) {
							localStorage.setItem(`${msg.room}_isRead`, 0);

							setTimeout(() => {
								localStorage.setItem(`${msg.room}_isRead`, 1);
							}, 2000);
						}
					});
				}
			}
		},
		onLogin() {
			if (!this.uid) {
				let { uid } = getLocalStorage("uid");
				if (uid) {
					this.uid = uid;
					this.accessLog.saveAccessLog(uid);
				}
				setTimeout(this.onLogin, 100);
				return;
			}

			const { serviceId } = getLocalStorage("serviceId");
			const { service } = getLocalStorage("service");
			let { lang } = getLocalStorage("lang");
			if (!lang) {
				lang = "cn";
			}
			let that = this;
			this.login
				.post({
					name: this.uid,
					type: 1,
					serviceId: serviceId,
					service: service,
					lang: lang,
					title: document.title,
					url: document.URL,
					desc: this.getMetaInfo("description"),
				})
				.then((data) => {
					// 登录接口不进行操作，只记录获取的参数，是否弹出都在 talk 中进行判断
					const historyTime = new Date(data.login_time).getTime();
					localStorage.setItem(`${that.uid}_historyTime`, historyTime);
					that.loadingShow=false
          if(data.need_form===1) {
            that.sendBoxShow=false
          } else {
            that.sendBoxShow=true
          }
					that.app_alert = data.app_alert; // APP 是否开启每日首条新消息弹出
					that.pc_alert = data.alert; // PC 是否开启每日首条新消息弹出
					// 跟随模板  200
					// 蓝色 - 1
					// 橙色 - 2
					// 紫色 - 3
					// 绿色 - 4

					// 自定义色系  color: "rgb(255, 0, 0)|rgb(18, 46, 225)"
					if (data.color?.includes("style")) {
						const color = JSON.parse(data.color);
						let colorz1, colorz2;
						if (color.type && color.type == "linear") {
							colorz1 = `rgba(${color.points[0].red},${color.points[0].green},${color.points[0].blue},${color.points[0].alpha})`;
							colorz2 = `rgba(${color.points[1].red},${color.points[1].green},${color.points[1].blue},${color.points[1].alpha})`;
						} else {
							colorz1 = color.style;
							colorz2 = color.style;
						}

						document
							.getElementById("jljw_IM_GdImBox")
							.classList.add("colorzdy");
						const element = document.getElementById("jljw_IM_GdImBox");
						const styleElement = document.createElement("style");
						styleElement.textContent = `
            #jljw_IM_GdImBox {
              --colorz1: ${colorz1};
              --colorz2: ${colorz2};
            }
          `;
						element.prepend(styleElement);
					} else {
						if (data.color == "1") {
							document
								.getElementById("jljw_IM_GdImBox")
								.classList.add("color1");
						} else if (data.color == "2") {
							document
								.getElementById("jljw_IM_GdImBox")
								.classList.add("color2");
						} else if (data.color == "3") {
							document
								.getElementById("jljw_IM_GdImBox")
								.classList.add("color3");
						} else if (data.color == "4") {
							document
								.getElementById("jljw_IM_GdImBox")
								.classList.add("color4");
						}
					}

					setTimeout(function() {
						document.getElementById("jljw_IM_GdImBox").style.display = "block";
					}, 100);
				})
				.catch((err) => {
					console.log(err);
					setTimeout(function() {
						document.getElementById("jljw_IM_GdImBox").style.display = "block";
						that.loadingShow=false
					}, 100);
				});
		},
		doWelcome() {
			var that = this;
			let { welts } = getLocalStorage("welts");
			let { weltsMsg } = getLocalStorage("weltsMsg");
			let { popwin } = getLocalStorage("popwin");

			// debugger
			let configShowIM = true;
			if (popwin == null) {
				// 兼容老旧版本
				configShowIM = false;
			} else {
				let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				);
				isMobile = false; // 2025年02月25日，强行修改移动端逻辑为PC
				// 1：都关闭(默认）
				// 2：都自动弹出
				// 3：pc关闭，手机弹出
				// 4：pc弹出，手机关闭
				if (popwin == 1 || popwin == "1") {
					configShowIM = false; // 都不弹出
				} else if (popwin == 2 || popwin == "2") {
					configShowIM = true; // 都自动弹出
				} else if (popwin == 3 || popwin == "3") {
					if (isMobile) {
						configShowIM = true; // 手机弹出
					}
				} else if (popwin == 4 || popwin == "4") {
					if (!isMobile) {
						configShowIM = true; // pc弹出
					}
				}
				// 手机上全部不弹出 2024年12月04日
				if (isMobile) configShowIM = false;
			}

			let date = new Date();
			date.setDate(date.getDate() + 1);
			// 隔日再弹窗
			if (welts == null || parseInt(welts) > date.getTime()) {
				that.firstWelcome = true;
				setLocalStorage({ welts: date.getTime() });
			}

			if (weltsMsg == null || weltsMsg == undefined) {
				that.welcome.post({ name: that.uid }).then((data) => {
					if (!data || (data && typeof data == "string" && !data.trim())) {
						return;
					}
					if (that.firstWelcome) {
						// 修改为：如果点击过了展示/隐藏聊天框，则不再自动弹出showIM 2024年11月21日
						if (!that.showIMByClick) {
							that.showPopOrTips(configShowIM);
						}
					}
					// that.message.push({ type: "welcome", message: data });
					weltsMsg = data;
					setLocalStorage({ weltsMsg: weltsMsg });
					var msgWelcome = [{ type: "welcome", message: weltsMsg }];
					if (that.message && that.message.length > 0) {
						if (that.message[0].message != msgWelcome[0].message) {
							that.message = msgWelcome.concat(that.message);
						}
					} else {
						that.message = msgWelcome.concat(that.message);
					}
				});
			} else {
				if (that.firstWelcome) {
					// 修改为：如果点击过了展示/隐藏聊天框，则不再自动弹出showIM 2024年11月21日
					// console.log("welcome来了")
					if (!that.showIMByClick) {
						// that.showIM = configShowIM
						that.showPopOrTips(configShowIM);
					}
					// if(!that.showIM) that.mobmessagehint = true;
				}
				var msgWelcome = [{ type: "welcome", message: weltsMsg }];
				if (that.message && that.message.length > 0) {
					if (that.message[0].message != msgWelcome[0].message) {
						that.message = msgWelcome.concat(that.message);
					}
				} else {
					that.message = msgWelcome.concat(that.message);
				}
			}
		},
		onImage(obj) {
			let data = new FormData();
			data.append("file", obj.file);
			let headers = { "Content-Type": "multipart/form-data" };
			UploadFile(data, headers, this.uploadStepProcess)
				.then((file) => {
					this.image.post({ room: this.uid, image: file });
				})
				.catch((err) => {
					console.log(err);
					this.uploadStep = 0;
				});
		},
		onFile(obj) {
			let data = new FormData();
			data.append("file", obj.file);
			let headers = { "Content-Type": "multipart/form-data" };
			UploadFile(data, headers, this.uploadStepProcess)
				.then((file) => {
					this.file.post({ room: this.uid, file: file });
				})
				.catch((err) => {
					console.log(err);
					this.uploadStep = 0;
				});
		},
		// onAudio(obj) {
		//   let data = new FormData();
		//   data.append("file", obj.file);
		//   let headers = { "Content-Type": "multipart/form-data" };
		//   UploadFile(data, headers, this.uploadStepProcess)
		//     .then(file => {
		//       this.audio.post({ room: this.uid, audio: file });
		//     })
		//     .catch(err => {
		//       console.log(err);
		//       this.uploadStep = 0;
		//     });
		// },
		// onVideo(obj) {
		//   let data = new FormData();
		//   data.append("file", obj.file);
		//   let headers = { "Content-Type": "multipart/form-data" };
		//   UploadFile(data, headers, this.uploadStepProcess)
		//     .then(file => {
		//       this.video.post({ room: this.uid, video: file });
		//     })
		//     .catch(err => {
		//       console.log(err);
		//       this.uploadStep = 0;
		//     });
		// },
		onTalk(msg, msgType, replyToId) {
			// console.log('app提交id',replyToId)
			msgType = msgType || "talk";
			let reqId = (Math.random() * 10000).toFixed(0);
			if (!beetlex.websocket.connectedSucc) {
				let { uid } = getLocalStorage("uid");
				var msgObject = {
					dateTime: new Date().toString(),
					history: false,
					message: msg,
					msgId: 0,
					reqId: 0,
					read: false,
					room: uid,
					replyTo: replyToId,
					type: msgType,
					sendFail: true,
					user: { name: uid },
				};
				beetlex.websocket.receive(msgObject);
				return;
			} else {
				let { uid } = getLocalStorage("uid");
				var msgObject = {
					dateTime: new Date().toString(),
					history: false,
					message: msg,
					msgId: 0,
					read: false,
					room: uid,
					replyTo: replyToId,
					type: msgType,
					clientMsgId: reqId, // 当前发送的id
					sendFail: true,
					user: { name: uid },
				};
				beetlex.websocket.receive(msgObject);
			}
			let that = this;
			if (msgType == "saveFormMsg") {
				this.saveFormMsg.post(msg).then((dataResp) => {
					console.log(`表单回复： ${dataResp}`);
				});
				return; // 如果发送了表单类型，就不要发送talk类型的消息了
			} else {
			}
			let req = this.talk
				.post({
					room: this.uid,
					message: msg,
					replyTo: replyToId,
					// replyTo: 337132354246144,
					clientMsgId: reqId,
				})
				.then((dataResp) => {
					that.isCloseQuote = true;
					// if (that.serviceName) return;
					// {"id":"8","url":"/DefaultMessage","code":200,"data":"Hi"}
					let { dftMsg } = getLocalStorage("dftMsg");
					let date = new Date();
					if (date.getTime() > dftMsg) {
						date.setDate(date.getDate() + 1);
						setLocalStorage({ dftMsg: date.getTime() });
						const { service } = getLocalStorage("service");
						// 2024年12月03日，不再使用defaultMessage
						// this.defaultMsg.post({ name: service }).then((data) => {
						//   // console.log("dftMsg");
						//   // console.log(data.code);
						//   if (data.code == undefined) {
						//     if (data != "") this.message.push({ type: "dftMsg", message: data });
						//   }
						// });
					}
				});
		},
		onPreMsg(msg) {
			if (!beetlex.websocket.connectedSucc) {
				return;
			}
			let that = this;
			clearInterval(this.preMsgTimeout);
			this.preMsgTimeout = setInterval(function() {
				that.preMsg.post({
					room: that.uid,
					message: JSON.stringify(msg),
				});
				// console.log(msg);
				clearInterval(that.preMsgTimeout);
			}, 200);
		},
		onRead(msg) {
			let list = this.message.filter(
				(m) => m.msgId <= msg.message && m.read === false
			);
			if (list.length > 0) {
				for (let m of list) {
					m.read = true;
				}
			}
		},
		getRandomString() {
			const char = [
				"0",
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"A",
				"B",
				"C",
				"D",
				"E",
				"F",
				"G",
				"H",
				"I",
				"J",
				"K",
				"L",
				"M",
				"N",
				"O",
				"P",
				"Q",
				"R",
				"S",
				"T",
				"U",
				"V",
				"W",
				"R",
				"S",
				"T",
				"U",
				"V",
				"W",
				"X",
				"Y",
				"Z",
			];
			let str = "";
			for (let i = 0; i < 10; i++) {
				str += char[Math.floor(Math.random() * char.length)];
			}
			return str;
		},
		unLoadPage() {
			beetlex.websocket.close();
			this.accessLog.closeVisit();
		},
		move(e) {
			let odiv = e.target.parentNode; //获取目标元素

			//算出鼠标相对元素的位置
			let disX = e.clientX - odiv.offsetLeft;
			let disY = e.clientY - odiv.offsetTop;
			document.onmousemove = (e) => {
				//鼠标按下并移动的事件
				//用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
				let left = e.clientX - disX,
					top = e.clientY - disY,
					leftMax =
						(document.documentElement.clientWidth ||
							document.body.clientWidth) - odiv.offsetWidth,
					topMax =
						(document.documentElement.clientHeight ||
							document.body.clientHeight) - odiv.offsetHeight;

				if (left < 0) left = 0;
				if (left > leftMax) left = leftMax;
				if (top < 0) top = 0;
				if (top > topMax) top = topMax;
				//移动当前元素
				odiv.style.left = left + "px";
				odiv.style.top = top + "px";
			};
			document.onmouseup = () => {
				document.onmousemove = null;
				document.onmouseup = null;
			};
		},
		viewImage(src) {
			this.preview = true;
			this.viewImg = src;
		},
		cancelView() {
			this.preview = false;
		},
		uploadStepProcess(e) {
			this.uploadStep = ((e.loaded / e.total) * 100).toFixed(2);
		},
		showNotification(title, message) {
			let that = this;
			let timer;
			(function(timer) {
				let index = 0;
				clearInterval(timer);
				timer = setInterval(function() {
					if (that.isShine === false) {
						clearInterval(timer);
						document.head.getElementsByTagName("title")[0].innerHTML = title;
						return;
					}
					if (index % 2) {
						document.head.getElementsByTagName("title")[0].innerHTML =
							"[　　　　　　 ]" + title;
					} else {
						document.head.getElementsByTagName("title")[0].innerHTML =
							"[New Message]" + title;
					}
					index++;
					if (index > 20) {
						clearInterval(timer);
						document.head.getElementsByTagName("title")[0].innerHTML = title;
					}
				}, 500);
			})(timer);

			setTimeout(function() {
				if (window.Notification && Notification.permission !== "denied") {
					Notification.requestPermission(function(status) {
						if (status === "granted") {
							if (that.isShine === false) {
								return;
							}
							let n = new Notification(title, { body: message });
							n.onclick = function() {
								window.focus();
							};
						}
					});
				}
			}, 1000);
		},
		// statusCheck() {
		//   let that = this;
		//   setInterval(function() {
		//     if (!beetlex.websocket.status) return;
		//     that.check.post({}).then(() => {
		//       console.log("statusCheck");
		//     });
		//   }, 5000);
		// }
		initPanelEmail() {
			let panelEmail =
				this.getJsParam("im.js", "panelEmail") == "true" ? true : false;

			panelEmail = panelEmail && this.aiState != 1;
			// 获取所有参数
			let youNameShow = this.getJsParam("im.js", "n") == "true" ? true : false;
			let emailShow = this.getJsParam("im.js", "e") == "true" ? true : false;
			let phoneShow = this.getJsParam("im.js", "p") == "true" ? true : false;
			let contentShow = this.getJsParam("im.js", "c") == "true" ? true : false;

			this.show.isName = youNameShow || false;
			this.show.isEmail = emailShow || false;
			this.show.isPhone = phoneShow || false;
			this.show.isText = contentShow || false;

			// 如果不显示，就不要求输入了
			this.data.isNameRequired =
				this.getJsParam("im.js", "nr") == "true" ? true : false;
			this.data.isEmailRequired =
				this.getJsParam("im.js", "er") == "true" ? true : false;
			this.data.isPhoneRequired =
				this.getJsParam("im.js", "pr") == "true" ? true : false;
			this.data.isContentRequired =
				this.getJsParam("im.js", "cr") == "true" ? true : false;

			this.data.isNameRequired = this.data.isNameRequired && this.show.isName;
			this.data.isEmailRequired =
				this.data.isEmailRequired && this.show.isEmail;
			this.data.isPhoneRequired =
				this.data.isPhoneRequired && this.show.isPhone;
			this.data.isContentRequired =
				this.data.isContentRequired && this.show.isText;
			if (
				!this.show.isName &&
				!this.show.isEmail &&
				!this.show.isPhone &&
				!this.show.isText
			) {
				this.show.isName = true;
				this.show.isEmail = true;
				this.data.isEmailRequired = true;
				this.show.isText = true;
			}
			// // 如果不显示，就不要求输入了
			// this.data.isNameRequired = this.show.isName && this.data.isNameRequired;
			// this.data.isNameRequired = this.show.isEmail && this.data.isNameRequired;
			// this.data.isNameRequired = this.show.isPhone && this.data.isNameRequired;
			// this.data.isNameRequired = this.show.isText && this.data.isNameRequired;
			if (panelEmail) {
				this.showPanelEmail(true);
			} else {
				this.showPanelEmail(false); // 兼容老旧版本
			}
		},
		showPanelEmail(isShow) {
			var strShow = isShow ? "none" : "block";
			var strNone = !isShow ? "none" : "block";
			this.$refs.msgView.$refs.msgList.style.display = strShow;
			this.$refs.sendBoxView.$refs.r_ifInput.style.display = strShow;
			this.$refs.r_jljw_IM_inquiry.style.display = strNone;
			isShow && this.$refs.jljw_IM_Name.focus();
			this.updateHeight(isShow);
		},
		btnSendEmail() {
			if (this.checkOnBlur() == false) {
				return;
			}
			// var jljw_IM_Name = this.$refs.jljw_IM_Name.value;
			// var jljw_IM_mail = this.$refs.jljw_IM_mail.value;
			// var jljw_IM_textarea = this.$refs.jljw_IM_textarea.value;
			// this.$refs.jljw_IM_Name.value;
			// this.$refs.jljw_IM_mail.value;
			// this.$refs.jljw_IM_phone.value;
			// this.$refs.jljw_IM_textarea.value;
			this.sendMsgEmail(
				this.$refs.jljw_IM_Name,
				this.$refs.jljw_IM_mail,
				this.$refs.jljw_IM_phone,
				this.$refs.jljw_IM_textarea
			);
			this.loadingState = 1;
			setTimeout(() => {
				// 隐藏loading动画，显示感谢图标
				this.loadingState = 2;
				setTimeout(() => {
					// 清空输入框
					if (this.$refs.jljw_IM_Name) this.$refs.jljw_IM_Name.value = "";
					if (this.$refs.jljw_IM_mail) this.$refs.jljw_IM_mail.value = "";
					if (this.$refs.jljw_IM_phone) this.$refs.jljw_IM_phone.value = "";
					if (this.$refs.jljw_IM_textarea)
						this.$refs.jljw_IM_textarea.value = "";
					this.loadingState = 0;
					// this.showPanelEmail(false);
				}, 1000);
			}, 1000);
			// 判断是否填写姓名、邮箱、内容
			// if (jljw_IM_Name == '') {
			//   // this.showPanelTips('name cannot be empty!');
			// }
			// if (jljw_IM_mail == '') {
			//   // this.showPanelTips('E-mail can not be empty!');
			//   return;
			// } else {
			//   var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
			//   var isok = reg.test(jljw_IM_mail);
			//   if (!isok) {
			//     // 正则判断邮箱格式是否正确
			//     this.showPanelTips = true;
			//     this.msgPanelTips = 'E-mail format error';
			//     // this.showPanelTips('E-mail format error');
			//     return;
			//   }
			// }
			// if (jljw_IM_textarea == '') {
			//   // if (jljw_IM_mail == '') {
			//   //   this.showPanelTips('the content can not be empty!');
			//   // } else {
			//   //   this.showPanelTips('the content can not be blank!');
			//   // }
			//   this.showPanelTips('the content can not be blank!');
			//   return;
			// }

			// 如果都不为空
			// if (jljw_IM_mail != '' && jljw_IM_textarea != '') {
			//   // 加载loading动画

			// }
		},
		showPanelTips(str) {
			// this.msgEmailTips = str;
			// this.isShowHintEmail = true;
			// setTimeout(()=> {
			//   this.isShowHintEmail = false;
			// }, 1500)
		},
		sendMsgEmail(uName, uEmail, uPhone, uContent) {
			// var msg = "";
			// if (uName) {
			//   uName = ` ${uName},`;
			// } else {
			//   uName = "";
			// }
			uName = uName && uName.value;
			uEmail = uEmail && uEmail.value;
			uPhone = uPhone && uPhone.value;
			uContent = uContent && uContent.value;
			uName = uName || "";
			uEmail = uEmail || "";
			uPhone = uPhone || "";
			uContent = uContent || "";
			var msg = `Hello, I am interested in your company's products, please contact me:${uName},   ${uEmail},   ${uPhone},   ${uContent}`;
			this.onTalk(msg);
		},
		// handleBlur(){

		// },
		// handlePhoneBlur(){

		// },
		// handleContentBlur(){

		// },
		// handleNameBlur(){

		// },
		checkOnBlur() {
			this.isShowHint = true;
			var jljwEl = this.$refs.jljw_IM_Name;
			if (jljwEl && jljwEl.value == "" && this.data.isNameRequired) {
				// this.showPanelTips('Your name can not be empty!');
				this.msgPanelTips = "Your name can not be empty!";
				return false;
			}
			var jljw_IM_EL = this.$refs.jljw_IM_mail;
			if (jljw_IM_EL && jljw_IM_EL.value == "" && this.data.isEmailRequired) {
				this.msgPanelTips = "E-mail can not be empty!";
				return false;
			}
			if (jljw_IM_EL) {
				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				var isok = reg.test(jljw_IM_EL.value);
				if (!isok && this.data.isEmailRequired) {
					this.msgPanelTips = "E-mail format error";
					return false;
				}
			}

			var jljw_phoneEl = this.$refs.jljw_IM_phone;
			if (
				jljw_phoneEl &&
				jljw_phoneEl.value == "" &&
				this.data.isPhoneRequired
			) {
				this.msgPanelTips = "Phone/WhatsApp can not be empty!";
				return false;
			}

			var jljw_contentEL = this.$refs.jljw_IM_textarea.value;
			if (
				jljw_contentEL &&
				jljw_contentEL.value == "" &&
				this.data.isContentRequired
			) {
				this.msgPanelTips = "Message can not be empty!";
				return false;
			}
			this.msgPanelTips = "";
			this.isShowHint = false;
			return true;
		},
		getJsParam(jsName, paramName) {
			var retJsonArr = [],
				retVal = null;
			var rName = new RegExp(jsName + "(\\?(.*))?$");
			var jss = document.getElementsByTagName("script");

			for (var i = 0; i < jss.length; i++) {
				var j = jss[i];

				if (j.src && j.src.match(rName)) {
					var oo = j.src.match(rName)[2];
					var t = void 0,
						r = void 0;

					if (oo && (t = oo.match(/([^&=]+)=([^=&]+)/g))) {
						for (var l = 0; l < t.length; l++) {
							r = t[l];
							var tt = r.match(/([^&=]+)=([^=&]+)/);

							if (tt) {
								retJsonArr.push({
									key: tt[1],
									val: tt[2],
								});

								if (
									paramName != undefined &&
									paramName.length > 0 &&
									paramName == tt[1]
								) {
									retVal = tt[2];
								}
							}
						}
					}
				}
			}

			return paramName != undefined && paramName.length > 0 ? retVal : null;
		},
		updateHeight(isShow) {
			if (isShow) {
				this.heightGDImbBox = 451.78;
				if (!this.show.isName) this.heightGDImbBox -= 51.78;
				if (!this.show.isEmail) this.heightGDImbBox -= 51.78;
				if (!this.show.isPhone) this.heightGDImbBox -= 51.78;
				if (!this.show.isText) this.heightGDImbBox -= 119.59;
				// this.heightGDImbBox = 400;
			} else {
				this.heightGDImbBox = 588;
			}
		},
		onSwitchAi() {
			switch (this.aiState) {
				case 1:
					this.aiState = 3;
					break;
				case 3:
					this.aiState = 1;
					break;
			}
			// console.log("aiState", this.aiState);
			this.switchAi
				.post({
					aiState: this.aiState,
					roomId: this.uid,
				})
				.then((res) => {
					// console.log(res);
				});
		},
		getMetaInfo(nameMeta) {
			var listMeta = document.querySelectorAll("meta");
			for (var i = 0; i < listMeta.length; i++) {
				var infoMeta = listMeta[i];
				if (nameMeta == infoMeta.name) {
					return infoMeta.content;
				}
			}
			return "";
		},
		checkUnreadMsgs() {
			let { historyId } = getLocalStorage("historyId");
			if (!historyId) {
				this.numMsgUnRead = this.message.length || 1;
				return;
			}
			var numUnread = 0;
			for (var i = 0; i < this.message.length; i++) {
				var msg = this.message[i];
				var idTemp = msg.msgId;
				if (!idTemp) continue;
				if (msg.user && msg.user.name === this.uid) continue;

				// 如果消息类型是"notify"但不是以"客服移交给"开头，或者消息类型是"contactR"，则跳过（continue）
				// 其他情况下（包括普通消息和以"客服移交给"开头的notify消息）会继续执行后面的代码，被计算在内
				// console.log(msg);
				if (
					msg.type === "askGuide" ||
					(msg.type === "notify" &&
						!msg.message.includes("客服移交给") &&
						!msg.message.includes("客服撤回一条消息")) ||
					msg.type === "contactR"
				) {
					continue;
				}
				if (idTemp > historyId) numUnread++;
			}
			this.numMsgUnRead = numUnread;
		},
	},
	mounted() {
		var hasTrueValue = Object.values(this.data).some(function(value) {
			return value === true;
		});
		// console.log(hasTrueValue, 9999);
		if (hasTrueValue) {
			this.isGdImBoxHit = false;
		} else {
			this.isGdImBoxHit = true;
		}
	},
	watch: {
	},
};
</script>

<style scoped>
.tm {
	position: relative;
}
</style>
